var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElAvatar',{staticClass:"user-avatar",class:{ 'is-default': !_vm.avatarUrl },attrs:{"size":_vm.size,"src":_vm.imageUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }